import React from 'react';
import { useResponsive } from '@sg/garnish';

import { useLocalizationContext } from '@order/Localization';

import { Modal } from '../Modal';

// ─────────────────────────────────────────────────────────────────────────────

export const SweetpassPaymentMethodAddModal = (
  props: SweetpassPaymentMethodAddModalProps,
) => {
  const { visible, onRequestClose } = props;

  // ─── Context ─────────────────────────────────────────────────────────

  const { t } = useLocalizationContext();
  const { match } = useResponsive();

  // ─────────────────────────────────────────────────────────────────────

  return (
    <Modal
      fitHeight
      visible={visible}
      accessibilityLabel={t('sweetpass.signed-in.add-payment-method-title')}
      presentationStyle="pageSheet"
      size={match(['full', 'small'])}
      onRequestClose={onRequestClose}
    >
      <Modal.Header onClose={onRequestClose}>
        {t('sweetpass.signed-in.add-payment-method-title')}
      </Modal.Header>
    </Modal>
  );
};

// ─── Types ─────────────────────────────────────────────────────────────

type SweetpassPaymentMethodAddModalProps = Readonly<{
  visible: boolean;
  onRequestClose: () => void;
}>;
